import { createActions } from 'redux-actions';

export const {
  updateFilterFieldsCustomers,
  searchCustomers,
  changeTypeListCustomers,
  countFiltersCustomers,
  resetFiltersCustomers,
} = createActions(
  'UPDATE_FILTER_FIELDS_CUSTOMERS',
  'SEARCH_CUSTOMERS',
  'CHANGE_TYPE_LIST_CUSTOMERS',
  'COUNT_FILTERS_CUSTOMERS',
  'RESET_FILTERS_CUSTOMERS'
);
